import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import DriverTabData from './DriverTab';
import type { GenericList } from './models/JobSharedInterfaces';
import { useParams } from 'react-router-dom';
import { GetQuery } from './Shared';

const DriverJobsTeamData = () => {
    const { truckId } = useParams();
    const [loading, setLoading] = useState(true);
    const [driver, setDriver] = useState("");
    const [teamLead, setTeamLead] = useState("");
    const [team, setTeam] = useState<GenericList[]>([]);

    useEffect(() => {
        window.scrollTo(0, 0);
        getData();
    }, []);

    const getData = async () => {
        const apiUrl = "GetTruckTeam?TruckId=" + truckId;
        var result = await GetQuery(apiUrl);

        if (result.error) {
            toast.error("Error getting data!");
        } else {
            
            setDriver(result.data.driver);
            setTeamLead(result.data.teamLead);
            setTeam(result.data.team);
            setLoading(false);
        };
    }

    const driverTabsMobile = <DriverTabData tab="driverjobs" truckId={Number(truckId)} />

    const renderDetails = (
        <div>
            <div className="mobileFont marginTop10 marginBottom10">
                <h2 className="marginBottom10">Truck Team</h2>
                <span className="label-mobile--inline margin5">{teamLead}</span>
                <hr></hr>
                <span className="label-mobile--inline margin5">{driver}</span>
                <hr></hr>
                <div className={Number(truckId) <= 0 ? "hidden" : ""}>
                    {team.map(member =>
                        <span key={member.id} className="label-mobile--inline margin5">{member.name}</span>
                    )}
                    <hr></hr>
                </div>
            </div>
            <div>
                {driverTabsMobile}
            </div>
        </div>
    );


    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return <div>
        {contents}
    </div>;
}

export default DriverJobsTeamData;